/* ParentKit · Screens Off, Childhood On
   - Cart drawer with "Add for the kids" order bumps and the ₹79 bundle swap
   - Mobile sticky buy bar (shows after the hero scrolls away)
   - Look-inside carousel dots
   - Tracker form redirect
   No dependencies. Uses Shopify's AJAX Cart API only. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.SOCO && window.SOCO.moneyFormat) || '₹{{amount_no_decimals}}';
    var v = cents / 100;
    var noDec = Math.round(v).toLocaleString('en-IN');
    var dec = v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec)
      .replace(/\{\{\s*amount\s*\}\}/, dec);
  };

  var api = {
    get: function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); },
    add: function (items) {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); }); } return r.json(); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
  };

  /* ---------------------------------------------------------------- Cart drawer */
  function CartDrawer(root) {
    this.root = root;
    this.panel = root.querySelector('.soco-cart__panel');
    this.body = root.querySelector('[data-cart-body]');
    this.foot = root.querySelector('[data-cart-foot]');
    this.cfg = {
      kit: Number(root.dataset.kit) || 0,
      colouring: Number(root.dataset.colouring) || 0,
      busters: Number(root.dataset.busters) || 0,
      bundle: Number(root.dataset.bundle) || 0,
      colouringPrice: Number(root.dataset.colouringPrice) || 0,
      bustersPrice: Number(root.dataset.bustersPrice) || 0,
      bundlePrice: Number(root.dataset.bundlePrice) || 0,
      colouringImg: root.dataset.colouringImg || '',
      bustersImg: root.dataset.bustersImg || '',
      strings: {}
    };
    try {
      var sEl = document.querySelector('[data-cart-strings]');
      if (sEl) { this.cfg.strings = JSON.parse(sEl.textContent); }
    } catch (e) { /* keep defaults */ }
    this.cart = null;
    this.busy = false;
    this.lastFocus = null;
    this.bind();
  }

  CartDrawer.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]') || e.target.classList.contains('soco-cart__scrim')) { self.close(); }
      var rm = e.target.closest('[data-remove]');
      if (rm) { self.setQty(rm.dataset.remove, 0); }
    });
    this.root.addEventListener('change', function (e) {
      var bump = e.target.closest('[data-bump]');
      if (bump) { self.onBump(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.root.open) { self.close(); } });
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-soco-add]');
      if (!trigger) { return; }
      var id = Number(trigger.dataset.socoAdd);
      if (!id) { return; }
      e.preventDefault();
      self.open();
      self.render(null, true);
      self.enqueue(function () {
        return self.ensureInCart(id).then(function () {
          // Adding the kit from any button applies the homepage's pending add-on selection (see Addons).
          if (id === self.cfg.kit && window.socoAddons) { return window.socoAddons.applyPending(); }
        }).then(function () { return self.refresh(); });
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-soco-cart-open]')) { e.preventDefault(); self.open(); self.refresh(); }
    });
  };

  CartDrawer.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.root.open = true;
    this.root.setAttribute('open', '');
    document.body.classList.add('soco-cart-open');
    var c = this.root.querySelector('[data-cart-close]'); if (c) { c.focus(); }
  };
  CartDrawer.prototype.close = function () {
    this.root.open = false;
    this.root.removeAttribute('open');
    document.body.classList.remove('soco-cart-open');
    if (this.lastFocus && this.lastFocus.focus) { this.lastFocus.focus(); }
  };

  /* Every cart mutation goes through one queue, so a double-tap or a page tick racing a drawer tick
     can never run two add/change sequences at once (which is how a bundle could be added twice). */
  CartDrawer.prototype.enqueue = function (fn) {
    var self = this;
    this.chain = (this.chain || Promise.resolve())
      .then(function () { self.busy = true; return fn(); })
      .catch(function (err) { self.showError(err && err.message); return self.refresh(); })
      .then(function () { self.busy = false; });
    return this.chain;
  };
  CartDrawer.prototype.idle = function () { return (this.chain || Promise.resolve()).then(function () { return true; }); };

  CartDrawer.prototype.find = function (variantId) {
    if (!this.cart) { return null; }
    for (var i = 0; i < this.cart.items.length; i++) { if (this.cart.items[i].variant_id === variantId) { return this.cart.items[i]; } }
    return null;
  };

  CartDrawer.prototype.ensureInCart = function (variantId) {
    var self = this;
    return api.get().then(function (cart) {
      self.cart = cart;
      if (self.find(variantId)) { return cart; }
      return api.add([{ id: variantId, quantity: 1 }]);
    });
  };

  CartDrawer.prototype.refresh = function () {
    var self = this;
    return api.get().then(function (cart) { self.cart = cart; self.render(cart); return cart; });
  };

  CartDrawer.prototype.setQty = function (key, qty) {
    var self = this, cfg = this.cfg;
    this.render(this.cart, true);
    return this.enqueue(function () {
      var line = null;
      if (self.cart) { self.cart.items.forEach(function (it) { if (it.key === key) { line = it; } }); }
      return api.change(key, qty).then(function (cart) {
        self.cart = cart;
        // Add-ons never stay without the kit: removing the kit also removes colouring / busters / bundle.
        if (line && line.variant_id === cfg.kit && qty === 0) {
          if (window.socoAddons) { window.socoAddons.clearPending(); }
          return self.applyAddons(false, false);
        }
        self.render(cart);
      });
    });
  };

  /* Add-on logic (shared by the drawer's bumps and the homepage tick boxes):
     both wanted → bundle only; one wanted → that single; none → nothing. Never bundle + single together.
     Always works from a fresh copy of the cart. Call it from inside enqueue(). */
  CartDrawer.prototype.applyAddons = function (wantC, wantB) {
    var self = this, cfg = this.cfg;
    return api.get().then(function (cart) {
      self.cart = cart;
      var ops = [];
      var haveC = self.find(cfg.colouring), haveB = self.find(cfg.busters), haveBundle = self.find(cfg.bundle);
      var hasKit = !!self.find(cfg.kit);
      if (!hasKit) { wantC = false; wantB = false; } // add-ons never go in without the kit
      var useBundle = wantC && wantB && cfg.bundle;
      if (useBundle) {
        if (haveC) { ops.push(['change', haveC.key, 0]); }
        if (haveB) { ops.push(['change', haveB.key, 0]); }
        if (!haveBundle) { ops.push(['add', cfg.bundle]); }
        else if (haveBundle.quantity > 1) { ops.push(['change', haveBundle.key, 1]); }
      } else {
        if (haveBundle) { ops.push(['change', haveBundle.key, 0]); }
        if (wantC && !haveC) { ops.push(['add', cfg.colouring]); }
        if (!wantC && haveC) { ops.push(['change', haveC.key, 0]); }
        if (wantB && !haveB) { ops.push(['add', cfg.busters]); }
        if (!wantB && haveB) { ops.push(['change', haveB.key, 0]); }
      }
      var chain = Promise.resolve();
      ops.forEach(function (op) {
        chain = chain.then(function () { return op[0] === 'add' ? api.add([{ id: op[1], quantity: 1 }]) : api.change(op[1], op[2]); });
      });
      return chain;
    }).then(function () { return self.refresh(); });
  };

  CartDrawer.prototype.onBump = function () {
    var self = this;
    this.root.querySelectorAll('.soco-bump').forEach(function (b) { b.classList.add('soco-bump--busy'); });
    this.enqueue(function () {
      // Read the boxes at run time, so rapid toggles end in the state the parent last chose.
      var wantC = !!self.root.querySelector('[data-bump="colouring"]:checked');
      var wantB = !!self.root.querySelector('[data-bump="busters"]:checked');
      return self.applyAddons(wantC, wantB);
    });
  };

  CartDrawer.prototype.showError = function (msg) {
    var el = this.root.querySelector('[data-cart-error]');
    if (!el) { return; }
    el.textContent = msg || this.cfg.strings.error || 'Something went wrong. Please try again.';
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 5000);
  };

  CartDrawer.prototype.render = function (cart, loading) {
    var cfg = this.cfg, s = cfg.strings, self = this;
    var html = '';
    if (loading && !cart) {
      this.body.innerHTML = '<div class="soco-cart__empty"><p>' + (s.loading || 'Loading…') + '</p></div>';
      return;
    }
    cart = cart || { items: [], total_price: 0, item_count: 0 };
    var hasBundle = !!this.find(cfg.bundle);
    var hasC = hasBundle || !!this.find(cfg.colouring);
    var hasB = hasBundle || !!this.find(cfg.busters);
    var bumpIds = [cfg.colouring, cfg.busters, cfg.bundle];

    if (!cart.items.length) {
      html += '<div class="soco-cart__empty"><p>' + (s.empty || 'Your cart is empty.') + '</p>' +
        (cfg.kit ? '<button type="button" class="soco-btn soco-btn--sm" data-soco-add="' + cfg.kit + '">' + (s.addKit || 'Add the Reset Kit') + '</button>' : '') + '</div>';
    } else {
      cart.items.forEach(function (it) {
        if (bumpIds.indexOf(it.variant_id) !== -1) { return; }
        html += '<div class="soco-cart__line">' +
          (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_140x$1$2') + '" alt="" width="62" loading="lazy">' : '') +
          '<div class="soco-cart__line-info"><span class="soco-cart__line-title">' + esc(it.product_title) + '</span>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="soco-cart__line-sub">' + esc(it.variant_title) + '</span>' : (s.kitSub ? '<span class="soco-cart__line-sub">' + s.kitSub + '</span>' : '')) +
          (it.quantity > 1 ? '<span class="soco-cart__line-sub">× ' + it.quantity + '</span>' : '') +
          '<button type="button" class="soco-cart__remove" data-remove="' + it.key + '">' + (s.remove || 'Remove') + '</button></div>' +
          '<div class="soco-cart__line-price"><b>' + money(it.final_line_price) + '</b>' +
          (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : (it.compare_at_price && it.compare_at_price > it.price ? '<s>' + money(it.compare_at_price * it.quantity) + '</s>' : '')) +
          '</div></div>';
      });

      if (cfg.colouring && cfg.busters) {
        html += '<div class="soco-cart__bumps-head"><span class="soco-pill" style="align-self:flex-start">' + (s.bumpPill || 'Add for the kids') + '</span><b>' + (s.bumpTitle || 'Screen-free fun, ready to print') + '</b></div>';
        html += bumpRow('colouring', hasC, cfg.colouringImg, 84, s.colouringTitle, s.colouringSub, cfg.colouringPrice);
        html += bumpRow('busters', hasB, cfg.bustersImg, 60, s.bustersTitle, s.bustersSub, cfg.bustersPrice);
        if (cfg.bundle && cfg.bundlePrice) {
          var save = cfg.colouringPrice + cfg.bustersPrice - cfg.bundlePrice;
          html += '<div class="soco-cart__bundle"' + (hasBundle ? '' : ' style="opacity:.75"') + '><span>' + (s.both || 'Both together') + ': ' + money(cfg.bundlePrice) + '</span>' +
            (save > 0 ? '<span>' + (s.save || 'You save') + ' ' + money(save) + '</span>' : '') + '</div>';
        }
      }

      html += '<div class="soco-cart__totals">';
      cart.items.forEach(function (it) { html += '<div><span>' + esc(shortTitle(it.product_title)) + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</span><span>' + money(it.final_line_price) + '</span></div>'; });
      html += '<div class="soco-cart__total"><span>' + (s.total || 'Total') + '</span><span>' + money(cart.total_price) + '</span></div></div>';
    }
    html += '<div class="soco-cart__error" data-cart-error hidden></div>';
    this.body.innerHTML = html;

    var btn = this.foot.querySelector('[data-checkout]');
    if (btn) {
      btn.textContent = (s.checkout || 'Checkout') + (cart.item_count ? ' · ' + money(cart.total_price) : '');
      btn.setAttribute('aria-disabled', cart.item_count ? 'false' : 'true');
    }
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    // The theme's cart-updated event: the homepage add-on boxes mirror the cart from this.
    document.dispatchEvent(new CustomEvent('soco:cart', { detail: { cart: cart, loading: !!loading } }));

    function bumpRow(key, checked, img, w, title, sub, price) {
      return '<label class="soco-bump' + (loading ? ' soco-bump--busy' : '') + '"><input type="checkbox" data-bump="' + key + '"' + (checked ? ' checked' : '') + ' aria-label="' + esc(title || key) + '">' +
        (img ? '<img src="' + img + '" alt="" width="' + w + '" loading="lazy">' : '') +
        '<span class="soco-bump__info"><span class="soco-bump__title">' + esc(title || '') + '</span><span class="soco-bump__sub">' + esc(sub || '') + '</span></span>' +
        '<span class="soco-bump__price">' + money(price) + '</span></label>';
    }
    function shortTitle(t) { return t.replace(/\s*\(.*\)\s*$/, ''); }
  };

  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------------------------------------------------------- Homepage add-on tick boxes
     The cart is the single source of truth.
     - Kit not in cart: ticks are a pending selection (sessionStorage), applied when the kit is added
       from ANY button on the page (hero, sticky bar, this section, the drawer's own "Add the Reset Kit").
     - Kit in cart: ticks mirror the cart (soco:cart event) and write straight to it via the drawer's
       applyAddons(), with the singles-to-bundle swap. Nothing is ever pre-ticked. */
  function Addons(root, drawer) {
    this.root = root; this.drawer = drawer;
    this.cfg = {
      kit: Number(root.dataset.kit) || 0, kitPrice: Number(root.dataset.kitPrice) || 0,
      colouring: Number(root.dataset.colouring) || 0, colouringPrice: Number(root.dataset.colouringPrice) || 0,
      busters: Number(root.dataset.busters) || 0, bustersPrice: Number(root.dataset.bustersPrice) || 0,
      bundle: Number(root.dataset.bundle) || 0, bundlePrice: Number(root.dataset.bundlePrice) || 0,
      label: root.dataset.buttonLabel || 'Get the Reset Kit · [price]'
    };
    this.boxC = root.querySelector('[data-addon="colouring"]');
    this.boxB = root.querySelector('[data-addon="busters"]');
    this.button = root.querySelector('[data-value-button]');
    this.kitInCart = false;
    this.busy = false;
    var self = this;
    root.addEventListener('change', function (e) { if (e.target.closest('[data-addon]')) { self.onChange(); } });
    document.addEventListener('soco:cart', function (e) { if (!e.detail.loading) { self.syncFromCart(e.detail.cart); } });
    // Initial state: from the cart if the kit is there, otherwise from the pending selection.
    api.get().then(function (cart) { drawer.cart = cart; self.syncFromCart(cart); }).catch(function () { self.setBoxes(self.pending()); });
  }
  Addons.prototype.pending = function () {
    try { var p = JSON.parse(sessionStorage.getItem('soco-addons') || 'null'); return p && typeof p === 'object' ? { c: !!p.c, b: !!p.b } : { c: false, b: false }; }
    catch (e) { return { c: false, b: false }; }
  };
  Addons.prototype.setPending = function (c, b) { try { sessionStorage.setItem('soco-addons', JSON.stringify({ c: !!c, b: !!b })); } catch (e) { /* private mode */ } };
  Addons.prototype.clearPending = function () { try { sessionStorage.removeItem('soco-addons'); } catch (e) { /* ignore */ } this.setBoxes({ c: false, b: false }); };
  Addons.prototype.setBoxes = function (st) {
    if (this.boxC) { this.boxC.checked = !!st.c; }
    if (this.boxB) { this.boxB.checked = !!st.b; }
    this.updatePrice();
  };
  Addons.prototype.wants = function () { return { c: !!(this.boxC && this.boxC.checked), b: !!(this.boxB && this.boxB.checked) }; };
  Addons.prototype.updatePrice = function () {
    if (!this.button) { return; }
    var w = this.wants(), cfg = this.cfg, total = cfg.kitPrice;
    if (w.c && w.b && cfg.bundle) { total += cfg.bundlePrice; } else { if (w.c) { total += cfg.colouringPrice; } if (w.b) { total += cfg.bustersPrice; } }
    this.button.textContent = cfg.label.replace('[price]', money(total));
  };
  Addons.prototype.syncFromCart = function (cart) {
    if (!cart) { return; }
    var cfg = this.cfg, inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id] = true; });
    this.kitInCart = !!inCart[cfg.kit];
    if (this.kitInCart) {
      var bundle = !!inCart[cfg.bundle];
      this.setBoxes({ c: bundle || !!inCart[cfg.colouring], b: bundle || !!inCart[cfg.busters] });
      try { sessionStorage.removeItem('soco-addons'); } catch (e) { /* ignore */ }
    } else {
      this.setBoxes(this.pending());
    }
  };
  Addons.prototype.onChange = function () {
    var self = this, w = this.wants();
    this.updatePrice();
    if (!this.kitInCart) { this.setPending(w.c, w.b); return; }
    this.busy = true;
    this.root.querySelectorAll('.soco-value__addon').forEach(function (l) { l.classList.add('is-busy'); });
    this.drawer.enqueue(function () { var now = self.wants(); return self.drawer.applyAddons(now.c, now.b); })
      .then(function () { self.busy = false; self.root.querySelectorAll('.soco-value__addon').forEach(function (l) { l.classList.remove('is-busy'); }); });
  };
  /* Called by the drawer (inside its queue) right after the kit is added from any button. */
  Addons.prototype.applyPending = function () {
    var p = this.pending();
    if (!p.c && !p.b) { return Promise.resolve(); }
    try { sessionStorage.removeItem('soco-addons'); } catch (e) { /* ignore */ }
    return this.drawer.applyAddons(p.c, p.b);
  };

  /* ---------------------------------------------------------------- Sticky bar */
  function stickyBar() {
    var bar = document.querySelector('[data-soco-sticky]');
    if (!bar) { return; }
    var hero = document.querySelector('[data-soco-hero]');
    if (!hero || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(hero);
  }

  /* ---------------------------------------------------------------- Carousel dots */
  function carousels() {
    document.querySelectorAll('[data-soco-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('.soco-inside__track');
      var dots = wrap.querySelectorAll('.soco-dots button');
      var items = track.querySelectorAll('.soco-inside__item');
      if (!items.length) { return; }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { items[i] && items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); });
      });
      var update = function () {
        var x = track.scrollLeft, idx = 0, best = Infinity;
        items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - track.offsetLeft - x); if (d < best) { best = d; idx = i; } });
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------------------------------------------------------------- Tracker form */
  function trackerForm() {
    var form = document.querySelector('[data-soco-leadform]');
    if (!form) { return; }
    var redirect = form.dataset.redirect;
    var posted = form.dataset.posted === 'true';
    if (posted && redirect) { window.location.replace(redirect); return; }
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = form.dataset.sending || 'Sending…'; }
    });
  }

  function copyLinks() {
    document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.copyLink || location.href, label = btn.textContent;
        var done = function () { btn.textContent = btn.dataset.copied || 'Copied'; setTimeout(function () { btn.textContent = label; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); }); }
        else { window.prompt('Copy this link', url); }
      });
    });
  }

  /* ---------------------------------------------------------------- Free plan page analytics
     Fires GA4 + Meta Pixel events for the download buttons and the Reset Kit CTA.
     Every call is guarded so nothing breaks when a tag isn't loaded. */
  function planTracking() {
    var root = document.querySelector('[data-soco-plan]');
    if (!root) { return; }
    var name = root.dataset.planName || '3 Din Zero Screen';
    var ga = function (ev, params) {
      try { if (typeof window.gtag === 'function') { window.gtag('event', ev, params); } } catch (e) { /* no GA4 */ }
      try { if (Array.isArray(window.dataLayer)) { window.dataLayer.push(Object.assign({ event: ev }, params)); } } catch (e) { /* no GTM */ }
    };
    var fb = function (ev, params) {
      try { if (typeof window.fbq === 'function') { window.fbq('track', ev, params); } } catch (e) { /* no Pixel */ }
    };
    root.addEventListener('click', function (e) {
      var dl = e.target.closest('[data-download]');
      if (dl) {
        var type = dl.dataset.download || 'a4';
        var href = dl.getAttribute('href') || '';
        ga('file_download', { content_name: name, file_type: type, file_extension: 'pdf', file_name: href.split('/').pop().split('?')[0], link_url: href });
        fb('Lead', { content_name: name, content_category: type });
        return;
      }
      var kit = e.target.closest('[data-cta="reset-kit"]');
      if (kit) { ga('select_promotion', { promotion_name: '3din_plan_page', creative_name: 'next_step_card' }); }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    copyLinks();
    planTracking();
    var drawer = document.querySelector('[data-soco-cart]');
    if (drawer) { window.socoCart = new CartDrawer(drawer); }
    var value = document.querySelector('[data-soco-value]');
    if (value && window.socoCart) { window.socoAddons = new Addons(value, window.socoCart); }
    stickyBar();
    carousels();
    trackerForm();
  });
})();
